package one.primehealth.analytics

import one.primehealth.analytics.events.AppEvent
import one.primehealth.app.BaseAppConfig

actual class AmplitudePlatform actual constructor(appConfig: BaseAppConfig) {
    actual fun logEvent(event: AppEvent) {
    }

    actual fun setUserId(userId: String) {
    }
}